import { render, staticRenderFns } from "./goToRedsys.vue?vue&type=template&id=ecdd1b98"
import script from "./goToRedsys.vue?vue&type=script&lang=js"
export * from "./goToRedsys.vue?vue&type=script&lang=js"
import style0 from "./goToRedsys.vue?vue&type=style&index=0&id=ecdd1b98&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports